/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * Agency
 * Additive marketplace compliance preparation. No payment or pricing operations.
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  AgencyObject,
  GetAgencyAcceptanceCopyParams,
  GetAgencyAgreementParams,
  GetAgencyReconciliationParams,
  GetAgencyStatusParams
} from './models';

import { customFetch } from '../custom-fetch';
import type { ErrorType , BodyType } from '../custom-fetch';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetPublicAgencyShopDisclosureUrl = (storeId: number,) => {




  return `/api/agency/public/shops/${storeId}/disclosure`
}

export const getPublicAgencyShopDisclosure = async (storeId: number, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetPublicAgencyShopDisclosureUrl(storeId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicAgencyShopDisclosureQueryKey = (storeId: number,) => {
    return [
    `/api/agency/public/shops/${storeId}/disclosure`
    ] as const;
    }


export const getGetPublicAgencyShopDisclosureQueryOptions = <TData = Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError = ErrorType<unknown>>(storeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicAgencyShopDisclosureQueryKey(storeId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>> = ({ signal }) => getPublicAgencyShopDisclosure(storeId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: storeId !== null && storeId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicAgencyShopDisclosureQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>>
export type GetPublicAgencyShopDisclosureQueryError = ErrorType<unknown>



export function useGetPublicAgencyShopDisclosure<TData = Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError = ErrorType<unknown>>(
 storeId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyShopDisclosure>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicAgencyShopDisclosureQueryOptions(storeId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAgencyAcceptanceCopyUrl = (acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agency/acceptances/${acceptanceId}/copy?${stringifiedParams}` : `/api/agency/acceptances/${acceptanceId}/copy`
}

export const getAgencyAcceptanceCopy = async (acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams, options?: RequestInit): Promise<Blob | AgencyObject> => {

  return customFetch<Blob | AgencyObject>(getGetAgencyAcceptanceCopyUrl(acceptanceId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyAcceptanceCopyQueryKey = (acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams,) => {
    return [
    `/api/agency/acceptances/${acceptanceId}/copy`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyAcceptanceCopyQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError = ErrorType<unknown>>(acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyAcceptanceCopyQueryKey(acceptanceId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>> = ({ signal }) => getAgencyAcceptanceCopy(acceptanceId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: acceptanceId !== null && acceptanceId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyAcceptanceCopyQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>>
export type GetAgencyAcceptanceCopyQueryError = ErrorType<unknown>



export function useGetAgencyAcceptanceCopy<TData = Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError = ErrorType<unknown>>(
 acceptanceId: number,
    params?: GetAgencyAcceptanceCopyParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyAcceptanceCopy>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyAcceptanceCopyQueryOptions(acceptanceId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetPublicAgencyCustomerTermsUrl = () => {




  return `/api/agency/public/customer-terms`
}

export const getPublicAgencyCustomerTerms = async ( options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetPublicAgencyCustomerTermsUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPublicAgencyCustomerTermsQueryKey = () => {
    return [
    `/api/agency/public/customer-terms`
    ] as const;
    }


export const getGetPublicAgencyCustomerTermsQueryOptions = <TData = Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPublicAgencyCustomerTermsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>> = ({ signal }) => getPublicAgencyCustomerTerms({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError, TData> & { queryKey: QueryKey }
}

export type GetPublicAgencyCustomerTermsQueryResult = NonNullable<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>>
export type GetPublicAgencyCustomerTermsQueryError = ErrorType<unknown>



export function useGetPublicAgencyCustomerTerms<TData = Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getPublicAgencyCustomerTerms>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetPublicAgencyCustomerTermsQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAgencyComplianceUrl = () => {




  return `/api/admin/agency/compliance`
}

export const getAgencyCompliance = async ( options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetAgencyComplianceUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyComplianceQueryKey = () => {
    return [
    `/api/admin/agency/compliance`
    ] as const;
    }


export const getGetAgencyComplianceQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyCompliance>>, TError = ErrorType<unknown>>( options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyCompliance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyComplianceQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyCompliance>>> = ({ signal }) => getAgencyCompliance({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyCompliance>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyComplianceQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyCompliance>>>
export type GetAgencyComplianceQueryError = ErrorType<unknown>



export function useGetAgencyCompliance<TData = Awaited<ReturnType<typeof getAgencyCompliance>>, TError = ErrorType<unknown>>(
  options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyCompliance>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyComplianceQueryOptions(options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getCreateAgencyVersionUrl = () => {




  return `/api/admin/agency/versions`
}

export const createAgencyVersion = async (agencyObject: AgencyObject, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getCreateAgencyVersionUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(agencyObject)
  }
);}




export const getCreateAgencyVersionMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgencyVersion>>, TError,{data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createAgencyVersion>>, TError,{data: BodyType<AgencyObject>}, TContext> => {

const mutationKey = ['createAgencyVersion'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAgencyVersion>>, {data: BodyType<AgencyObject>}> = (props) => {
          const {data} = props ?? {};

          return  createAgencyVersion(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateAgencyVersionMutationResult = NonNullable<Awaited<ReturnType<typeof createAgencyVersion>>>
    export type CreateAgencyVersionMutationBody = BodyType<AgencyObject>
    export type CreateAgencyVersionMutationError = ErrorType<unknown>

    export const useCreateAgencyVersion = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createAgencyVersion>>, TError,{data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof createAgencyVersion>>,
        TError,
        {data: BodyType<AgencyObject>},
        TContext
      > => {
      return useMutation(getCreateAgencyVersionMutationOptions(options));
    }

export const getRecordAgencyReviewUrl = (id: number,) => {




  return `/api/admin/agency/versions/${id}/reviews`
}

export const recordAgencyReview = async (id: number,
    agencyObject: AgencyObject, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getRecordAgencyReviewUrl(id),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(agencyObject)
  }
);}




export const getRecordAgencyReviewMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAgencyReview>>, TError,{id: number;data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof recordAgencyReview>>, TError,{id: number;data: BodyType<AgencyObject>}, TContext> => {

const mutationKey = ['recordAgencyReview'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof recordAgencyReview>>, {id: number;data: BodyType<AgencyObject>}> = (props) => {
          const {id,data} = props ?? {};

          return  recordAgencyReview(id,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RecordAgencyReviewMutationResult = NonNullable<Awaited<ReturnType<typeof recordAgencyReview>>>
    export type RecordAgencyReviewMutationBody = BodyType<AgencyObject>
    export type RecordAgencyReviewMutationError = ErrorType<unknown>

    export const useRecordAgencyReview = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof recordAgencyReview>>, TError,{id: number;data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof recordAgencyReview>>,
        TError,
        {id: number;data: BodyType<AgencyObject>},
        TContext
      > => {
      return useMutation(getRecordAgencyReviewMutationOptions(options));
    }

export const getGetAgencyStatusUrl = (params?: GetAgencyStatusParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agency/status?${stringifiedParams}` : `/api/agency/status`
}

export const getAgencyStatus = async (params?: GetAgencyStatusParams, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetAgencyStatusUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyStatusQueryKey = (params?: GetAgencyStatusParams,) => {
    return [
    `/api/agency/status`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyStatusQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyStatus>>, TError = ErrorType<unknown>>(params?: GetAgencyStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyStatusQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyStatus>>> = ({ signal }) => getAgencyStatus(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyStatus>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyStatusQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyStatus>>>
export type GetAgencyStatusQueryError = ErrorType<unknown>



export function useGetAgencyStatus<TData = Awaited<ReturnType<typeof getAgencyStatus>>, TError = ErrorType<unknown>>(
 params?: GetAgencyStatusParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyStatus>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyStatusQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetAgencyAgreementUrl = (releaseId: number,
    params?: GetAgencyAgreementParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/agency/agreements/${releaseId}?${stringifiedParams}` : `/api/agency/agreements/${releaseId}`
}

export const getAgencyAgreement = async (releaseId: number,
    params?: GetAgencyAgreementParams, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetAgencyAgreementUrl(releaseId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyAgreementQueryKey = (releaseId: number,
    params?: GetAgencyAgreementParams,) => {
    return [
    `/api/agency/agreements/${releaseId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyAgreementQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyAgreement>>, TError = ErrorType<unknown>>(releaseId: number,
    params?: GetAgencyAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyAgreement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyAgreementQueryKey(releaseId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyAgreement>>> = ({ signal }) => getAgencyAgreement(releaseId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: releaseId !== null && releaseId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyAgreement>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyAgreementQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyAgreement>>>
export type GetAgencyAgreementQueryError = ErrorType<unknown>



export function useGetAgencyAgreement<TData = Awaited<ReturnType<typeof getAgencyAgreement>>, TError = ErrorType<unknown>>(
 releaseId: number,
    params?: GetAgencyAgreementParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyAgreement>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyAgreementQueryOptions(releaseId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getAcceptAgencyAgreementUrl = (releaseId: number,) => {




  return `/api/agency/agreements/${releaseId}/accept`
}

export const acceptAgencyAgreement = async (releaseId: number,
    agencyObject: AgencyObject, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getAcceptAgencyAgreementUrl(releaseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(agencyObject)
  }
);}




export const getAcceptAgencyAgreementMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptAgencyAgreement>>, TError,{releaseId: number;data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptAgencyAgreement>>, TError,{releaseId: number;data: BodyType<AgencyObject>}, TContext> => {

const mutationKey = ['acceptAgencyAgreement'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptAgencyAgreement>>, {releaseId: number;data: BodyType<AgencyObject>}> = (props) => {
          const {releaseId,data} = props ?? {};

          return  acceptAgencyAgreement(releaseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AcceptAgencyAgreementMutationResult = NonNullable<Awaited<ReturnType<typeof acceptAgencyAgreement>>>
    export type AcceptAgencyAgreementMutationBody = BodyType<AgencyObject>
    export type AcceptAgencyAgreementMutationError = ErrorType<unknown>

    export const useAcceptAgencyAgreement = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptAgencyAgreement>>, TError,{releaseId: number;data: BodyType<AgencyObject>}, TContext>, request?: SecondParameter<typeof customFetch>}
 ): UseMutationResult<
        Awaited<ReturnType<typeof acceptAgencyAgreement>>,
        TError,
        {releaseId: number;data: BodyType<AgencyObject>},
        TContext
      > => {
      return useMutation(getAcceptAgencyAgreementMutationOptions(options));
    }

export const getGetAgencyReconciliationUrl = (orderId: number,
    params?: GetAgencyReconciliationParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/agency/reconciliation/${orderId}?${stringifiedParams}` : `/api/admin/agency/reconciliation/${orderId}`
}

export const getAgencyReconciliation = async (orderId: number,
    params?: GetAgencyReconciliationParams, options?: RequestInit): Promise<AgencyObject | string> => {

  return customFetch<AgencyObject | string>(getGetAgencyReconciliationUrl(orderId,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetAgencyReconciliationQueryKey = (orderId: number,
    params?: GetAgencyReconciliationParams,) => {
    return [
    `/api/admin/agency/reconciliation/${orderId}`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetAgencyReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof getAgencyReconciliation>>, TError = ErrorType<unknown>>(orderId: number,
    params?: GetAgencyReconciliationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAgencyReconciliationQueryKey(orderId,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAgencyReconciliation>>> = ({ signal }) => getAgencyReconciliation(orderId,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAgencyReconciliation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetAgencyReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof getAgencyReconciliation>>>
export type GetAgencyReconciliationQueryError = ErrorType<unknown>



export function useGetAgencyReconciliation<TData = Awaited<ReturnType<typeof getAgencyReconciliation>>, TError = ErrorType<unknown>>(
 orderId: number,
    params?: GetAgencyReconciliationParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getAgencyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetAgencyReconciliationQueryOptions(orderId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







export const getGetShopAgencyReconciliationUrl = (storeId: number,
    orderId: number,) => {




  return `/api/agency/shops/${storeId}/reconciliation/${orderId}`
}

export const getShopAgencyReconciliation = async (storeId: number,
    orderId: number, options?: RequestInit): Promise<AgencyObject> => {

  return customFetch<AgencyObject>(getGetShopAgencyReconciliationUrl(storeId,orderId),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetShopAgencyReconciliationQueryKey = (storeId: number,
    orderId: number,) => {
    return [
    `/api/agency/shops/${storeId}/reconciliation/${orderId}`
    ] as const;
    }


export const getGetShopAgencyReconciliationQueryOptions = <TData = Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError = ErrorType<unknown>>(storeId: number,
    orderId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetShopAgencyReconciliationQueryKey(storeId,orderId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getShopAgencyReconciliation>>> = ({ signal }) => getShopAgencyReconciliation(storeId,orderId, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: storeId !== null && storeId !== undefined && orderId !== null && orderId !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError, TData> & { queryKey: QueryKey }
}

export type GetShopAgencyReconciliationQueryResult = NonNullable<Awaited<ReturnType<typeof getShopAgencyReconciliation>>>
export type GetShopAgencyReconciliationQueryError = ErrorType<unknown>



export function useGetShopAgencyReconciliation<TData = Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError = ErrorType<unknown>>(
 storeId: number,
    orderId: number, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof getShopAgencyReconciliation>>, TError, TData>, request?: SecondParameter<typeof customFetch>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getGetShopAgencyReconciliationQueryOptions(storeId,orderId,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}







